export const pushToDL = (data: any) => {
  const dataLayer = (window as any)?.dataLayer || []
  dataLayer.push(data)
}
